import { c as _c } from "react/compiler-runtime";
import type { ChatOnFinishCallback } from 'ai';
import { useCallback, useEffect } from 'react';
import { useNovaChat } from '../hooks/use-nova-chat';
import type { UIMessageWithMetadata } from '../lib/types';
interface OrphanedStreamRecoveryProps {
  chatUuid: string;
  chatTitle: string;
  initialMessages: UIMessageWithMetadata[];
  onStreamFinish: (params: {
    chatUuid: string;
    chatTitle: string;
    isStandaloneMode?: boolean;
  }) => Promise<void>;
}

/**
 * Renderless component that recovers orphaned streams after page refresh.
 * Uses AI SDK's useNovaChat hook to automatically resume the stream and
 * get notified when it completes via onFinish callback.
 *
 * This component doesn't render anything - it's purely for side effects.
 */
export function OrphanedStreamRecovery(t0) {
  const $ = _c(11);
  const {
    chatUuid,
    chatTitle,
    initialMessages,
    onStreamFinish
  } = t0;
  let t1;
  if ($[0] !== chatTitle || $[1] !== chatUuid || $[2] !== onStreamFinish) {
    t1 = async () => {
      await onStreamFinish({
        chatUuid,
        chatTitle
      });
    };
    $[0] = chatTitle;
    $[1] = chatUuid;
    $[2] = onStreamFinish;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleFinish = t1;
  let t2;
  if ($[4] !== chatUuid || $[5] !== handleFinish || $[6] !== initialMessages) {
    t2 = {
      chatUuid,
      initialMessages,
      onFinish: handleFinish
    };
    $[4] = chatUuid;
    $[5] = handleFinish;
    $[6] = initialMessages;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const chat = useNovaChat(t2);
  let t3;
  if ($[8] !== chat) {
    t3 = () => {
      chat.resumeStream();
    };
    $[8] = chat;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  return null;
}